/**
 * Takes an ISO8601 date string (e.g. 2024-01-01)
 * and splits it and returns a tuple of the
 * year and month values.
 *
 * @param date ISO8601 date string
 * @returns a tuple [year, month] as integers.
 */
export function splitDate(date: string): [number, number] {
    const parts = date.split("-");
    if(parts.length === 3 && parts[0] && parts[1]) {
        return [parseInt(parts[0]), parseInt(parts[1])];
    }
    return [0, 0];
}